import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/recursos_humanos/pais';
import Pais from './PaisList';


const ms2p = (state) => {
  return {
    ...state.pais_rh,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Pais);
